import React, { useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import CultureAssessment from './components/CultureAssessment';
import OrganizationSetup from './components/OrganizationSetup';

const CultureAssessmentPage = () => {
  const [organizationData, setOrganizationData] = useState(null);
  const [showAssessment, setShowAssessment] = useState(false);

  const handleOrganizationComplete = (data) => {
    setOrganizationData(data);
    setShowAssessment(true);
  };

  if (!showAssessment) {
    return (
      <div>
        <Header />
        <OrganizationSetup onComplete={handleOrganizationComplete} />
        <Footer />
      </div>
    );
  }

  return (
    <div className="culture-assessment-page">
      <Header />
      <div className="assessment-section">
        <div className="assessment-content">
          <CultureAssessment organizationData={organizationData} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CultureAssessmentPage;
